// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"343":"41fb29dd","668":"66a3c09a","736":"ac9c0f5b","787":"1f213201","879":"afb8052c"}[chunkId] + ".chunk.js";
};